import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Accordion, AccordionDetails, AccordionSummary, Grid } from '@mui/material'
import { groupBy, orderBy } from 'lodash'
import ServicesTable from './ServicesTable'
import DtoServiceSituation from 'exploitations/dto/DtoServiceSituation'

const ServicesAccordion = ({
    data = [],
    yearKey = '0000',
    expanded = '',
    setExpanded = () => { },
}) => {
    const groupedSituationsServices = groupBy(data, d => d.calculationDate)
    const orderdedKeys = orderBy(Object.keys(groupedSituationsServices), d => parseInt(d), ['desc'])

    return (
        <Grid size={12}>
            <Accordion
                expanded={expanded === `panel_${yearKey ?? ''}`}
                onChange={(_, isExpanded) => setExpanded(isExpanded ? `panel_${yearKey ?? ''}` : '')}
                sx={{ marginBottom: '5px', marginTop: '5px' }}
                key={`panel_${yearKey ?? ''}`}
            >
                <AccordionSummary>
                    {yearKey !== 'undefined' && yearKey || i18n.notDefined}
                </AccordionSummary>
                <AccordionDetails style={{ padding: '0 10 10 10' }}>
                    {orderdedKeys.map(situationKey => (
                        <ServicesTable
                            key={situationKey}
                            data={groupedSituationsServices[situationKey]}
                        />
                    ))}
                </AccordionDetails>
            </Accordion>
        </Grid>
    )
}

ServicesAccordion.propTypes = {
    data: PropTypes.arrayOf(PropTypes.instanceOf(DtoServiceSituation)),
    yearKey: PropTypes.string,
    expanded: PropTypes.string,
    setExpanded: PropTypes.func,
}

export default ServicesAccordion